import { render, staticRenderFns } from "./AdminEditDienstleister.vue?vue&type=template&id=4145148e&scoped=true&"
import script from "./AdminEditDienstleister.vue?vue&type=script&lang=js&"
export * from "./AdminEditDienstleister.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditDienstleister.vue?vue&type=style&index=0&id=4145148e&prod&lang=css&"
import style1 from "./AdminEditDienstleister.vue?vue&type=style&index=1&id=4145148e&prod&scoped=true&lang=css&"
import style2 from "./AdminEditDienstleister.vue?vue&type=style&index=2&id=4145148e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145148e",
  null
  
)

export default component.exports